<script setup>
import { useStoreStore } from '@/stores/store'
import Delimiter from '@sections/delimiter.vue'
import StoreCollection from '@sections/home-page/merch.vue'
import ColllectionBanners from '@sections/merch/collection-banners.vue'
import Hero from '@sections/merch/hero.vue'
import Socials from '@sections/merch/socials.vue'

const store = useStoreStore()
</script>
<template>
	<!-- <Hero /> -->
	<!-- <ColllectionBanners /> -->
	<StoreCollection v-for="collection in store.collections" :collection="collection" />
	<Socials />
	<Delimiter />
</template>
